// @ts-strict-ignore
import React, { useMemo } from 'react';
import { Box, ValuePair } from '@usealloy/component-library';
import { HeaderText, RuleBreakdownColumn, RuleBreakdownValue } from './styles';

// returns a string of a comma separated number
export const formatValue = (number: number) => number.toLocaleString();

export type RuleBreakdownProps = {
  evaluationPercentile?: number;
  numOfEvaluations?: number;
  thresholdType: '$ Amount' | 'Score' | 'Value';
  thresholdValue: number;
  totalEvaluations?: number;
  newThresholdValue: number | undefined;
  onSaveNewThresholdValue?: Function;
  onManualThresholdValueChange?: Function;
  manuallyEditedValue?: number;
  isManuallyEditing?: boolean;
  isEditable?: boolean;
};

const RuleBreakdown: React.FC<RuleBreakdownProps> = ({
  evaluationPercentile,
  numOfEvaluations,
  thresholdType,
  thresholdValue,
  totalEvaluations,
  newThresholdValue,
  onSaveNewThresholdValue,
  onManualThresholdValueChange,
  manuallyEditedValue,
  isManuallyEditing,
  isEditable = true,
}) => {
  const isThresholdValueValid = thresholdValue !== null && thresholdValue !== undefined;
  const formattedPercentage = evaluationPercentile ? `${evaluationPercentile}%` : 'N/A';
  const formattedEvaluationsText = (numOfEvaluations && totalEvaluations) ? `${formatValue(numOfEvaluations)} of ${formatValue(totalEvaluations)}` : 'N/A';

  const EditableThresholdValue = useMemo(() => (
    isThresholdValueValid
      ? (
        <ValuePair
          value={isManuallyEditing ? manuallyEditedValue : thresholdValue}
          dataType="integer"
          onSave={eventValue => onSaveNewThresholdValue(eventValue)}
          onChange={eventValue => onManualThresholdValueChange(eventValue)}
          isEditable={isEditable}
        />
      )
      : <RuleBreakdownValue>N/A</RuleBreakdownValue>
  ), [
    isManuallyEditing,
    isThresholdValueValid,
    manuallyEditedValue,
    onManualThresholdValueChange,
    onSaveNewThresholdValue,
    thresholdValue,
    isEditable,
  ]);

  const thresholdValueToDisplay = () => {
    if (newThresholdValue === undefined && manuallyEditedValue === undefined) {
      const formattedValueText = isThresholdValueValid ? formatValue(thresholdValue) : 'N/A';
      return <RuleBreakdownValue>{formattedValueText}</RuleBreakdownValue>;
    }
    return EditableThresholdValue;
  };

  return (
    <Box>
      <RuleBreakdownColumn>
        <HeaderText>% of Evaluations</HeaderText>
        <RuleBreakdownValue>{formattedPercentage}</RuleBreakdownValue>
      </RuleBreakdownColumn>
      <RuleBreakdownColumn>
        <HeaderText># of Evaluations</HeaderText>
        <RuleBreakdownValue>{formattedEvaluationsText}</RuleBreakdownValue>
      </RuleBreakdownColumn>
      <RuleBreakdownColumn>
        <HeaderText>{`${thresholdType} (Threshold)`}</HeaderText>
        {thresholdValueToDisplay()}
      </RuleBreakdownColumn>
    </Box>
  );
};

export default RuleBreakdown;
